import type { Channel } from "@/mocks/streams";
import type { FilterState } from "@/components/feature/FilterBar";

export function filterAndSortChannels(list: Channel[], filters: FilterState): Channel[] {
  const result = list.filter((channel) => {
    if (filters.status === "live" && !channel.isLive) return false;
    if (filters.status === "offline" && channel.isLive) return false;
    if (filters.level !== "all" && channel.hostLevel !== filters.level) return false;
    if (filters.language !== "all" && channel.language !== filters.language) return false;
    return true;
  });

  return result.sort((a, b) => {
    if (filters.sort === "popularity") return b.viewers - a.viewers;
    if (filters.sort === "duration") return b.startedMinutes - a.startedMinutes;
    return a.startedMinutes - b.startedMinutes;
  });
}

export function matchKeyword(channel: Channel, keyword: string, categoryName: string): boolean {
  const q = keyword.trim().toLowerCase();
  if (!q) return true;
  const haystack = [channel.title, channel.hostName, channel.description, categoryName, ...channel.tags]
    .join(" ")
    .toLowerCase();
  return haystack.includes(q);
}